import {createEntityAdapter} from '@reduxjs/toolkit';

/** @namespace SpotheroIQ.Adapters */

/**
 * Crud adapter for spotheroIQ rate thresholds. Sorts rate thresholds by id as a default
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const rateThresholdsAdapter = createEntityAdapter({
    sortComparer: (a, b) => a.id.localeCompare(b.id),
});
